const TITULO_DEFAULT = "¿Cómo contratar?";
const PASOS_DEFAULT = [
    { step: '1', text: 'Compará precios y coberturas' },
    { step: '2', text: 'Elegí la forma de pago' },
    { step: '3', text: 'Emití online tu póliza' },
    { step: '4', text: '¡Listo! Ya estás asegurado' },
];

interface Paso {
    step: string;
    text: string;
}

interface Props {
    titulo?: string;
    pasos?: Paso[];
}

export const PasosCotizar = ({ titulo = TITULO_DEFAULT, pasos = PASOS_DEFAULT }: Props) => {
    return (
        <div className="py-5 bg-f4">
            <div className="container">
                <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-black text-center mb-5">
                    {titulo}
                </h2>

                <div className="position-relative bg-line-lg">
                    <div className="row px-5 mb-50 position-relative">
                        {pasos.map(({ step, text }, index) => (
                            <div key={index} className="col-lg-3 text-center">
                                <div className="d-inline-flex justify-content-center align-items-center fs-30 fs-lg-50 fw-bold text-white bg-primary rounded-circle w-64p h-64p w-lg-105p h-lg-105p mb-10 mb-lg-20 border border-2 border-white shadow-3">
                                    {step}
                                </div>
                                <div className="fs-20 fs-lg-24 fw-bold lh-12 text-black mb-30">{text}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
